module.exports = __webpack_public_path__ + "img/blog-5.07b56aa1.webp";